import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ToastContainer } from 'react-toastify';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// Import pages/components
import Login from './auth/Login';
import Signup from './auth/Signup';
import VerifyOTP from './auth/VerifyOTP';
import ExplorePlaces from './components/ExplorePlaces';
import PlanTrip from './components/PlanTrip';
import HotelRooms from './components/HotelRooms';
import FamousFoods from './components/FamousFoods';
import ContactUs from './components/ContactUs';
import AboutUs from './components/AboutUs';
import Logout from './components/Logout';
import HomePage from './components/HomePage';
import Profile from './components/Profile';
import TravelDashboard from './components/TravelDashboard';
import Transportation from './components/Transportation';
import Vlogs from './components/Vlogs';
import UserProfile from "./components/UserProfile";
import GuideDashboard from './guides/GuideDashboard';
import BookGuide from './components/BookGuide';
import BookGuidePayment from './components/BookGuidePayment';
import GuideRegistration from './guides/GuideRegistration';
import AdminPage from './admin/AdminPage';
// Initialize React Query client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 15 * 60 * 1000, // 15 minutes
      refetchOnWindowFocus: true,
    },
  },
});

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <AuthProvider>
          <ToastContainer position="top-center" autoClose={5000} />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/home" element={<HomePage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/verify-otp" element={<VerifyOTP />} />
            <Route path="/logout" element={<Logout />} />
            <Route path="/explore-places" element={<ExplorePlaces />} />
            <Route path="/plan-trip" element={<PlanTrip />} />
            <Route path="/hotel-rooms" element={<HotelRooms />} />
            <Route path="/restaurants" element={<FamousFoods />} />
            <Route path="/transportation" element={<Transportation />} />
            <Route path="/dashboard" element={<TravelDashboard />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/vlogs" element={<Vlogs />} />
            <Route path="/user/:encodedEmail" element={<UserProfile />} />
            <Route path="/guide-dashboard" element={<GuideDashboard />} />
            <Route path='/book-guide' element={<BookGuide />} />
            <Route path='/book-guide-confirmation' element={<BookGuidePayment />} />
            <Route path='/guide-registration' element={<GuideRegistration />} />
            <Route path='/admin-panel' element={<AdminPage />} />
          </Routes>
        </AuthProvider>
      </Router>
    </QueryClientProvider>

  );
};

export default App;
